
const state = {
  id: null,
  title: '',
  owner_id: null,
  owner_type: '',
}

export const requiredFields = [
  { key: 'title' },
  { key: 'owner_id' },
  { key: 'owner_type' },
]

export default state
